<template>
  <v-footer
    dark
    color="#139393"
    padless
  >
    <v-card
      class="flex"
      flat
      tile
      color="#139393"
    >
      <v-card-text class="py-2 white--text text-center">
        Copyright ©{{ new Date().getFullYear() }} — <strong>Tapes To Digital.</strong> All Rights Reserved.
        <br>
          <span class="white--text" style="font-size: 0.9em;">Version: {{ version }}</span>
          <br>
        <router-link
          :to="{ name: 'TermsOfServiceView' }"
          class="white--text text-decoration-none mx-2"
        >
          Terms of Service
        </router-link>
        |
        <router-link
          :to="{ name: 'PrivacyPolicyView' }"
          class="white--text text-decoration-none mx-2"
        >
          Privacy Policy
        </router-link>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    components:{
      //
    },
    computed: mapState({
      //
    }),
    props:[
      //
    ],
    data: () => ({
      version: '0.1.7'
    }),
    created() {
      //
    },
    mounted() {
    },
    methods: {
      //
    }
  }
</script>